import React, { useEffect, useState } from 'react';
import { Layout, Drawer, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { MainContent } from './MainContent';
import { type BreadcrumbItem } from '@/shared/lib/breadcrumb-context';
import { siderStyles, layoutStyles } from '@/shared/styles/layoutStyles';

export const MainLayout: React.FC = () => {
  const [collapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  const location = useLocation();
  const [customBreadcrumbs, setCustomBreadcrumbs] = useState<BreadcrumbItem[] | null>(null);

  const sidebarWidth = 240;
  const collapsedWidth = 80;

  // Detect mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    setCustomBreadcrumbs(null);
  }, [location.pathname]);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <style>{siderStyles}</style>
      <Layout style={layoutStyles.mainLayout}>
        {/* Desktop: Show Sidebar */}
        {!isMobile && (
          <Sidebar
            collapsed={collapsed}
            width={sidebarWidth}
            collapsedWidth={collapsedWidth}
          />
        )}

        {/* Mobile: Hamburger button + Drawer */}
        {isMobile && (
          <>
            <Button
              className="mobile-menu-toggle"
              type="primary"
              icon={<MenuOutlined />}
              onClick={() => setMobileMenuOpen(true)}
              style={{
                position: 'fixed',
                top: 12,
                left: 12,
                zIndex: 1001,
                width: 44,
                height: 44,
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              }}
            />

            <Drawer
              placement="left"
              open={mobileMenuOpen}
              onClose={() => setMobileMenuOpen(false)}
              width={280}
              styles={{
                body: { padding: 0 }
              }}
            >
              <Sidebar
                collapsed={false}
                width={280}
                collapsedWidth={0}
                onNavigate={() => setMobileMenuOpen(false)}
              />
            </Drawer>
          </>
        )}

        <MainContent
          collapsed={collapsed}
          width={sidebarWidth}
          collapsedWidth={collapsedWidth}
          customBreadcrumbs={customBreadcrumbs}
          setCustomBreadcrumbs={setCustomBreadcrumbs}
          isMobile={isMobile}
        />
      </Layout>
    </>
  );
};